<template>
  <div class='sdk-download'>
    <div class='container'>
      <ul class='types'>
        <li :class='{active: sdkIndex === index}' 
          v-for="(item, index) in data.sdk" :key="`sdk-select-${item.title}`"
          :label="item.title"
          :value="index" @click='sdkIndex=index'>
          <div v-if="item.title!=='云会议'">{{item.title}}</div></li>
      </ul>
      <div class='demo' v-if='demo'>
        <div class='demo-item'>
          <div class='icon'>
            <img :src='demo.icon'/>
          </div>
          <div class='right'>
            <h3 class='name'>{{demo.name}}</h3>
            <p class='desc'>{{demo.desc}}</p>
            <div class='buttons'>
              <template v-for='(item, index) in demo.data'>
                <el-popover
                  :key='index'
                  v-if='item.imgPath'
                  placement="top"
                  width="240"
                  trigger="click">
                  <button class='button' slot='reference'>{{item.name}}</button>
                  <div class='demo-popover-img'>
                    <img :src='item.imgPath'/>
                  </div>
                </el-popover>
                <button v-else class='button' :key='index' @click='handleDownload(item.iframePath)'>{{item.name}}</button>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'SDKDownload',
  data() {
    return {
      data: {},
      sdkIndex: 0,
      demoActive: '0',
      sdkActive: '0',
    }
  },
  computed: {
    sdk() {
      return (this.data.sdk && this.data.sdk[this.sdkIndex]) ? this.data.sdk[this.sdkIndex] : [];
    },
    demo() {
      let res = null;
      if (this.data && this.data.demo && this.data.sdk && this.data.sdk.length > 0) {
        const name = this.data.sdk[this.sdkIndex].title;
        for (let i = 0; i < this.data.demo.length; i++) {
          if (this.data.demo[i].title === name) {
            return this.data.demo[i];
          }
        }
      }
      return res;
    },
  },
  mounted() {
    axios.get('/downloadDir/down.json').then(async ({data}) => {
      this.data = data;
    })
  },
  methods: {
    handleSelectChange() {
      this.sdkActive = '0';
    },
    handleDownload(iframePath) {
      window.open(iframePath, "_blank")
    }
  },
}
</script>

<style lang="less" scoped>
.sdk-download {
  .container {
    background: #fff;
    padding-bottom: 40px;
  }
  .sdk, .demo {
    margin-top: 10px;
    padding: 0 30px 63px;
    position: relative;
    h2 {
      font-size: 18px;
      font-weight: 400;
      text-align: center;
      color: #333333;
      line-height: 25px;
      padding: 17px;
    }
    /deep/ .el-tabs {
      border-top: 1px solid #e4e1e1;
      border-radius: 4px;
    }
    /deep/ .el-tabs__header {
      margin-bottom: 50px;
    }
    /deep/ .el-tabs__nav-wrap::after {
      height: 1px;
      background-color: #e4e1e1;
    }
    /deep/ .el-tabs__nav-scroll {
      display: flex;
      justify-content: center;
    }
    /deep/ .el-tabs__item {
      font-size: 15px;
      height: 50px;
      line-height: 50px;
      color: #666;
      &.is-active {
        color: #3E74F2;
      }
    }
  }
  .demo {
    padding-bottom: 0;
    .demo-item {
      display: flex;
      justify-content: center;
      align-items: center;
      // border: 1px solid #e4e1e1;
      border-radius: 4px;
      padding: 50px;
      .icon {
        width: 200px;
        height: 200px;
        background: #f6f8ff;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 180px;
          height: 180px;
        }
      }
      .right {
        margin-left: 20px;
        display: flex;
        flex-direction: column;
        .name {
          font-size: 18px;
          font-weight: 600;
          color: #333333;
          line-height: 25px;
          margin: 10px 0;
        }
        .desc {
          font-size: 16px;
          font-weight: 400;
          color: #666666;
          line-height: 22px;
          width: 550px;
        }
        .buttons {
          margin-top: 20px;
          >span+span, >span+.button, >.button+span {
            margin-left: 20px;
          }
        }
      }
    }
  }
  .button {
    height: 30px;
    line-height: 30px;
    background: linear-gradient(325deg,#3b71f2 7%, #8da8ff 95%);
    border-radius: 25px;
    padding: 0 20px;
    cursor: pointer;
    outline: none;
    border: none;
    color: #fff;
    font-size: 14px;
    font-weight: 400;
    &:hover {
      opacity: 0.9;
    }
    + .button {
      margin-left: 20px;
      margin-top: 20px;
    }
  }
}
.types{
  width: 260px;
  height: 55px;
  margin: 0 auto;
  padding: 30px 0 0;
  justify-content: space-between;
  display: -webkit-box; /* Chrome 4+, Safari 3.1, iOS Safari 3.2+ */  
  display: -moz-box; /* Firefox 17- */  
  display: -webkit-flex; /* Chrome 21+, Safari 6.1+, iOS Safari 7+, Opera 15/16 */  
  display: -moz-flex; /* Firefox 18+ */  
  display: -ms-flexbox; /* IE 10 */  
  display: flex; /* Chrome 29+, Firefox 22+, IE 11+, Opera 12.1/17/18, Android 4.4+ */  
  li{
    height: 25px;
    opacity: 1;
    font-size: 18px;
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: 400;
    text-align: left;
    color: #666666;
    line-height: 25px;
    letter-spacing: 0px;
    cursor: pointer;
    &.active {
      color: #3b72f2;
    }
  }
}
</style>